import type { Theme } from "@mui/material";

export const getDotColor = (type: "success" | "warning" | "error" | "neutral", theme: Theme) => {
  return type === "success"
    ? theme.palette.success.main
    : type === "warning"
      ? theme.palette.warning.main
      : type === "error"
        ? theme.palette.error.main
        : theme.palette.grey[500];
};

export const getLabelClassName = (bold?: boolean) =>
  bold
    ? "text-sm font-semibold text-theme-text-primary"
    : "text-sm font-medium text-theme-text-primary";
